import React from "react";
import UserTable from "./list/Userlist";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Users = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <UserTable/>
      </div>
    </div>
  );
};

export default Users;
